export default __webpack_public_path__ + "static/media/confirm3.4e253d55.png";